import { useFormContext } from "react-hook-form";

const countErrors = (node: unknown): number => {
  if (!node || typeof node !== "object") return 0;
  if ("message" in node && typeof (node as { message: unknown }).message === "string") return 1;
  return Object.values(node).reduce<number>((sum, child) => sum + countErrors(child), 0);
};

export const FormSubmitErrorBanner = () => {
  const {
    formState: { errors },
  } = useFormContext();

  const errorCount = countErrors(errors);
  if (errorCount === 0) return null;

  const plural = errorCount > 1 ? "s" : "";

  return (
    <p className="text-sm font-medium text-red-600" data-testid="form-submit-error-banner">
      Enregistrement non pris en compte : merci de remonter dans le formulaire, {errorCount} erreur{plural} restante{plural} (surlignée
      {plural} en rouge).
    </p>
  );
};
